import { render, staticRenderFns } from "./SignInSignUpLogo.vue?vue&type=template&id=fb585158"
import script from "./SignInSignUpLogo.vue?vue&type=script&lang=ts"
export * from "./SignInSignUpLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb585158')) {
      api.createRecord('fb585158', component.options)
    } else {
      api.reload('fb585158', component.options)
    }
    module.hot.accept("./SignInSignUpLogo.vue?vue&type=template&id=fb585158", function () {
      api.rerender('fb585158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/logo/SignInSignUpLogo.vue"
export default component.exports